import hlValidation from '@modules/husleie-framework/src/mixins/hlValidation';
export default {
  mixins: [hlValidation],
  beforeRouteLeave(to, from, next) {
    // If we are navigating to a page that is placed before the current route in the router config, we don't validate.
    const routes = this.$router.options.routes;
    const fromRouteIdx = routes.findIndex(route => route.name === from.name);
    const toRouteIdx = routes.findIndex(route => route.name === to.name);

    if (toRouteIdx < fromRouteIdx) {
      next();
    } else {
      this.$validator.errors.clear();
      this.$validator.validateAll().then(() => {
        if (this.hlIsFormValid()) {
          if (window) {
            // Put this route name in a "global" variable inside the window object, if it exists.
            // Other components, like NextBackBottomBar, might use this to check if we are
            // navigating *backwars* in history.
            window['_hlPrevValidPage'] = from.name;
            //console.log('from nae', from.name);
          }
          next();
        } else {
          // Scroll the first element with class is-invalid into view, and dont call next()
          this.$nextTick(() => {
            // Find all elements with the correct class or attribute set; next, find the first
            // element that seems to be visible and rendered on the screen. (The datepicker seems
            // to put an flag on a invisible element, stopping us from scrolling to that element. By
            // looping over the array and finding the first visible, we can make sure we are able to
            // scroll the view to that element)
            //
            const invalidElements = this.$el.querySelectorAll('.is-invalid, [aria-invalid=true]');
            let el;
            for (const candidate of invalidElements) {
              const b = candidate.getBoundingClientRect();
              // A element that are not rendered now visible on the screen will have x,y,height,width set to zero,
              // so if any of the values is non-zero, select that item.
              if (b.x !== 0 || b.y !== 0 || b.width !== 0 || b.height !== 0) {
                el = candidate;
                break;
              }
            }

            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            } else {
              console.error('Could not find invalid element to scroll to');
            }
          });
        }
      });
    }
  },
};
